// extracted by mini-css-extract-plugin
module.exports = {"content":"form-part_content__x3X9A","tipText":"form-part_tipText__1Xguq","errorMsg":"form-part_errorMsg__Jbk61"};